import { render, staticRenderFns } from "./BpmBizBatchCompleteDealModal.vue?vue&type=template&id=e3920b8a&scoped=true&"
import script from "./BpmBizBatchCompleteDealModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizBatchCompleteDealModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizBatchCompleteDealModal.vue?vue&type=style&index=0&id=e3920b8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3920b8a",
  null
  
)

export default component.exports